function Docs(props) {
  return (
    <div className="container">
      <h3>How to use Credit Card Buddy</h3>
      <p>
        Credit Card Buddy is a simple app that allows you to track your discounts among your credit cards and determine what would be the best one to use in a given scenario.
      </p>
      <p>
        Your data is stored directly on your device, and is currently not transferable, so it's recommended that you input everything on your phone or similar that you will have with you when making purchases.
      </p>
      <h4>Getting Started</h4>
      <p>
        To get started, simply add a credit card description and discounts via the "Add" button.  Each discount (say, 4% off) can apply to one or more categories, or subcategories.  To enter one:
      </p>
      <ul>
          <li>Add a discount / benefit description, such as "4% off"</li>
          <li>Add individual categories underneath it, which will be used when browsing discounts.  Categories and subcategories should be separated by "/".
              Examples are:</li>
          <ul>
              <li><em>restaurants</em> - if it applies to all restaurants</li>
              <li><em>restaurants/Chilis</em> - if it is a gift card to a specific restaurant</li>
              <li><em>travel/Southwest</em></li>
              <li><em>travel/Car Rental</em></li>
              <li><em>Gas</em></li>
          </ul>
          <li>If the benefit expires, enter a date in the "Good through" date picker.  It will automatically be removed after the expiration date.</li>
          <li>Hit Save</li>
      </ul>
      <h4>Browsing Discounts</h4>
      <p>
        To browse the discounts, simply click on the "Browse" button if not on the browse screen.  Categories will be listed with the benefit below.
      </p>
    </div>
  )
}

export default Docs;